import script from "./SearchUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchUsers.vue?vue&type=script&setup=true&lang=js"

import "./SearchUsers.vue?vue&type=style&index=0&id=ffb4106e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffb4106e"]])

export default __exports__